<template>
  <div class="mt-12">
    <div v-html="block.content"
      :class="{ 'bg-yellow-100 p-8 shadow-lg': block.options.content_type == 'info' }"></div>
    <pre v-if="debug">
      {{ block }}
    </pre>
  </div>
</template>

<script>
export default {
  data() {
    return {
      debug: false
    }
  },
  props: [ 'block' ]
}
</script>